import React, { useState, useMemo } from 'react';
import CalcShell from '../CalcShell';

export default function PermutationCalc() {
  const [n, setN] = useState(10);
  const [r, setR] = useState(3);
  const [showWork, setShowWork] = useState(false);
  const fact = k => { let f = 1; for (let i = 2; i <= k; i++) f *= i; return f; };
  const c = useMemo(() => {
    if (n < r || r < 0 || n < 0) return null;
    const P = fact(n) / fact(n - r);
    const C = P / fact(r);
    return { P, C };
  }, [n, r]);
  return (
    <CalcShell look="cnet" title="Permutation & Combination Calculator" subtitle="Compute nPr (order matters) and nCr (order does not matter).">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div>
          <div className="field"><label>n (total items)</label><input type="number" value={n} onChange={e => setN(+e.target.value || 0)} data-testid="perm-n"/></div>
          <div className="field"><label>r (chosen)</label><input type="number" value={r} onChange={e => setR(+e.target.value || 0)} data-testid="perm-r"/></div>
        </div>
        <div>
          {c ? (
            <table className="data-table"><tbody>
              <tr><td>nPr (Permutations)</td><td className="text-right font-semibold" data-testid="perm-P">{c.P.toLocaleString()}</td></tr>
              <tr><td>nCr (Combinations)</td><td className="text-right font-semibold" data-testid="perm-C">{c.C.toLocaleString()}</td></tr>
            </tbody></table>
          ) : <div className="text-red-600">Invalid: n must be ≥ r ≥ 0</div>}
        </div>
      </div>
      {c && (
        <div className="mt-4">
          <button onClick={() => setShowWork(v => !v)} data-testid="perm-show-work-toggle"
            className="text-sm px-4 py-1.5 rounded bg-slate-200 hover:bg-slate-300 text-slate-800 font-medium">
            {showWork ? '− Hide working' : '+ Show working'}
          </button>
          {showWork && (
            <div className="mt-4 p-5 bg-blue-50 border border-blue-100 rounded-xl" data-testid="perm-work-panel">
              <h3 className="text-lg font-bold text-slate-900 mb-3">Step-by-step working</h3>
              <ol className="list-decimal ml-5 space-y-2 text-slate-800 text-[15px] leading-7">
                <li><b>Permutation formula</b>: <span className="font-mono">nPr = n! / (n − r)!</span> — order matters (ABC ≠ CAB).</li>
                <li><b>Combination formula</b>: <span className="font-mono">nCr = n! / [r! · (n − r)!]</span> — order does not matter.</li>
                <li><b>Substitute</b>: <span className="font-mono">P({n}, {r}) = {n}! / ({n} − {r})! = {n}! / {n - r}! = <b className="text-[#4c7b25]">{c.P.toLocaleString()}</b></span></li>
                <li><b>Then</b>: <span className="font-mono">C({n}, {r}) = P({n}, {r}) / {r}! = {c.P.toLocaleString()} / {fact(r)} = <b className="text-[#4c7b25]">{c.C.toLocaleString()}</b></span></li>
                <li><b>Note</b>: nPr counts arrangements; nCr counts subsets. Always nCr ≤ nPr.</li>
              </ol>
            </div>
          )}
        </div>
      )}
    </CalcShell>
  );
}
